import { render, staticRenderFns } from "./CdlSaudeCadastro.vue?vue&type=template&id=66bfe76f&scoped=true&"
import script from "./CdlSaudeCadastro.vue?vue&type=script&lang=js&"
export * from "./CdlSaudeCadastro.vue?vue&type=script&lang=js&"
import style0 from "./CdlSaudeCadastro.vue?vue&type=style&index=0&id=66bfe76f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bfe76f",
  null
  
)

export default component.exports